export const state = {
  showing: false,
  color: '',
  text: '',
}

export const getters = {}

export const mutations = {
  SET_SNACKBAR_INIT(state) {
    state.showing = false
    state.color = ''
    state.text = ''
  },
  SET_SNACKBAR(state, newValue) {
    state.showing = true
    state.color = newValue.color
    state.text = newValue.text
  },
}

export const actions = {
  setSnackbar({ commit }, { color, text }) {
    const snackbar = {}
    snackbar.showing = true
    snackbar.color = color || 'success'
    snackbar.text = text
    commit('SET_SNACKBAR', snackbar)
  },
  resetSnackbar({ commit }) {
    commit('SET_SNACKBAR_INIT')
  },
}
